import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShareScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"share-screen, screen-sharing"} maskId="square-filled-radius-0-stroke-1-IconShareScreen"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM12 7.79289L15.7071 11.5L15 12.2071L12.5 9.70711V16H11.5V9.70711L9 12.2071L8.29289 11.5L12 7.79289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShareScreen;
